import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';
import { parseContract } from '@/lib/api/parse';

import { deviceMapPopupSchema, type DeviceMapPopup } from './map-popup-schemas';

/**
 * One Device's quick-view payload.
 *
 * **`404` is a live, unresolved defect, not a theoretical branch** (F13): 8 of the 28 markers the
 * deployed API returns from `GET /devices/tracking/map` resolve on no per-device route. It surfaces
 * here as a rejected promise, and the panel renders a retryable notice over its identity block rather
 * than refusing to open — see `<DeviceQuickView>`.
 */
export async function getDeviceMapPopup(deviceId: string): Promise<DeviceMapPopup> {
  const path = endpoints.devices.mapPopup(deviceId);
  return parseContract(deviceMapPopupSchema, await apiClient.get(path), path);
}
